if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // "Jetzt kaufen" follows the ATC button, which variant changes and pdp-inventory disable.
      this.buyNowButton = this.querySelector('[data-buy-now]');
      if (this.buyNowButton) {
        const syncBuyNow = () => { this.buyNowButton.disabled = this.submitButton.disabled; };
        syncBuyNow();
        new MutationObserver(syncBuyNow).observe(this.submitButton, { attributes: true, attributeFilter: ['disabled'] });
        // Back from checkout restores the page from bfcache with the button still loading.
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted || !this.redirecting) return;
          this.redirecting = false;
          this.buyNowButton.classList.remove('loading');
          this.buyNowButton.removeAttribute('aria-disabled');
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
        });
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      // "Jetzt kaufen" posts the same form, then goes straight to checkout instead of the drawer.
      const buyNow = !!evt.submitter?.hasAttribute('data-buy-now');
      const button = buyNow ? evt.submitter : this.submitButton;
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      const inventory = this.querySelector('pdp-inventory');
      if (inventory && !inventory.validate()) return;

      this.handleErrorMessage();

      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart && !buyNow) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // Duft des Monats: the free Mystery Traveler goes in first, so the drawer render below shows both.
      const giftReady = this.dataset.monthGift ? this.addMonthGift(this.dataset.monthGift) : Promise.resolve();

      giftReady
        .then(() => fetch(`${routes.cart_add_url}`, config))
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (buyNow) {
            this.redirecting = true;
            window.location.href = window.routes.checkout_url;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.redirecting) return;
          button.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) button.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // Adds the gift once per cart. A failure must never block the scent itself.
    addMonthGift(variantId) {
      return fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          if (cart.items.some((item) => String(item.variant_id) === String(variantId))) return;
          return fetch(`${routes.cart_add_url}.js`, {
            ...fetchConfig(),
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          });
        })
        .catch((error) => console.error(error));
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
